// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"5fd30b9f","240":"d7603496","369":"f10b9185","524":"d0f29b8d","565":"f1805904","574":"ae45ae5b","638":"ab94617a","718":"49a17a51","832":"71e0df6d"}[chunkId] + ".chunk.js";
};